import { createSelector } from 'reselect';

const selectGeneral = (state: any) => state.general;

/** ***************** EDIT DETAILS START *********************** */
export const selectEditDetails = createSelector(
	[selectGeneral],
	(general) => general.isDetailsEdit,
);
/** ***************** EDIT DETAILS END *********************** */

/** ***************** OPEN OFF CANVAS START *********************** */
export const selectOpenOffcanvas = createSelector(
	[selectGeneral],
	(general) => general.isOffcanvasOpen,
);
/** ***************** OPEN OFF CANVAS END *********************** */

/** ***************** COUNTRY LIST START *********************** */
export const selectCountryList = createSelector(
	[selectGeneral],
	(general) => general.getCountryListResponse,
);

export const selectCountryListResp = createSelector(
	[selectGeneral],
	(general) => general.getCountryListToken,
);
/** ***************** COUNTRY LIST END *********************** */

/** ***************** STATE LIST START *********************** */
export const selectStateListResp = createSelector(
	[selectGeneral],
	(general) => general.getStateListResponse,
);

export const selectStateList = createSelector(
	[selectGeneral],
	(general) => general.getStateListToken,
);
/** ***************** STATE LIST END *********************** */

/** ***************** CITY LIST START *********************** */
export const selectCityListResp = createSelector(
	[selectGeneral],
	(general) => general.getCityListResponse,
);

export const selectCityListArr = createSelector(
	[selectGeneral],
	(general) => general.getCityListArr,
);
/** ***************** CITY LIST END *********************** */

/** ***************** PINCODE LIST START *********************** */
export const selectPincodeList = createSelector(
	[selectGeneral],
	(general) => general.getPinCodeListResponse,
);
/** ***************** PINCODE LIST END *********************** */

/** ***************** DISTRICT LIST START *********************** */
export const selectDistrictList = createSelector(
	[selectGeneral],
	(general) => general.getDistrictListResponse,
);

export const selectDistrictListArr = createSelector(
	[selectGeneral],
	(general) => general.getDistrictListArr,
);
/** ***************** DISTRICT LIST END *********************** */

/** ***************** INDUSTRY LIST START *********************** */
export const selectGetIndustryListResponse = createSelector(
	[selectGeneral],
	(general) => general.getIndustryListResponse,
);

export const selectGetAllIndustryList = createSelector(
	[selectGeneral],
	(general) => general.getAllIndustryListArr,
);
/** ***************** INDUSTRY LIST END *********************** */

/** ***************** SUB INDUSTRY LIST START *********************** */
export const selectGetSubIndustryListResponse = createSelector(
	[selectGeneral],
	(general) => general.getSubIndustryListResponse,
);

export const selectGetSubIndustryListArr = createSelector(
	[selectGeneral],
	(general) => general.getSubIndustryListArr,
);
/** ***************** SUB INDUSTRY LIST END *********************** */

/** ***************** FETCH ALL BRANCHES START *********************** */
export const selectFetchAllBranchesResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchAllBranchesResponse,
);

export const selectFetchAllBranchesData = createSelector(
	[selectGeneral],
	(general) => general.fetchAllBranchesArr,
);
/** ***************** FETCH ALL BRANCHES END *********************** */

/** ***************** FETCH ALL PURPOSE OF LOAN START *********************** */
export const selectFetchAllPurposeOfLoanListResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchAllPurposeOfLoanListResponse,
);

export const selectFetchAllPurposeOfLoanListData = createSelector(
	[selectGeneral],
	(general) => general.fetchAllPurposeOfLoanListArr,
);
/** ***************** FETCH ALL PURPOSE OF LOAN END *********************** */

/** ***************** FETCH ALL PURPOSE OF LOAN TYPE START *********************** */
export const selectFetchAllPurposeOfLoanTypeResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchAllPurposeOfLoanTypeResponse,
);

export const selectFetchAllPurposeOfLoanTypeData = createSelector(
	[selectGeneral],
	(general) => general.fetchAllPurposeOfLoanTypeArr,
);
/** ***************** FETCH ALL PURPOSE OF LOAN TYPE END *********************** */

/** ***************** FETCH ALL BUSINESS START *********************** */
export const selectFetchAllBusinessResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchAllBusinessResponse,
);

export const selectFetchAllBusinessData = createSelector(
	[selectGeneral],
	(general) => general.fetchAllBusinessArr,
);
/** ***************** FETCH ALL BUSINESS END *********************** */

/** ***************** FETCH ALL PRODUCT TYPE START *********************** */
export const selectAllProductTypeFetchResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchAllProductTypesResponse,
);

export const selectFetchAllProductTypeData = createSelector(
	[selectGeneral],
	(general) => general.fetchAllProductTypesArr,
);
/** ***************** FETCH ALL PRODUCT TYPE END *********************** */

/** ***************** FETCH ALL PRODUCT START *********************** */
export const selectAllProductFetchResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchAllProductListResponse,
);

export const selectFetchAllProductData = createSelector(
	[selectGeneral],
	(general) => general.fetchAllProductListArr,
);
/** ***************** FETCH ALL PRODUCT END *********************** */

/** ***************** FETCH ALL BRANCH OFFICER START *********************** */
export const selectGetBranchAllOfficerResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchAllBranchOfficerResponse,
);

export const selectGetBranchAllOfficerData = createSelector(
	[selectGeneral],
	(general) => general.fetchAllBranchOfficerArr,
);
/** ***************** FETCH ALL BRANCH OFFICER END *********************** */

/** ***************** FETCH ALL CENTER START *********************** */
export const selectGetAllCenterResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchAllCenterResponse,
);

export const selectGetAllCenterData = createSelector(
	[selectGeneral],
	(general) => general.fetchAllCenterArr,
);
/** ***************** FETCH ALL CENTER END *********************** */

/** ***************** FETCH ALL INVESTOR START *********************** */
export const selectGetAllInverstorResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchAllInverstorResponse,
);

export const selectGetAllInverstorData = createSelector(
	[selectGeneral],
	(general) => general.fetchAllInverstorArr,
);
/** ***************** FETCH ALL INVESTOR END *********************** */

/** ***************** FETCH ALL GROUP START *********************** */
export const selectallGroupReponse = createSelector(
	[selectGeneral],
	(general) => general.fetchallGroupResponse,
);

export const selectallGroupData = createSelector(
	[selectGeneral],
	(general) => general.fetchallGroupArr,
);
/** ***************** FETCH ALL GROUP END *********************** */

/** ***************** FETCH ALL CENTER GROUP START *********************** */
export const selectGetCenterGroupResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchCenterGroupResponse,
);

export const selectGetCenterGroupData = createSelector(
	[selectGeneral],
	(general) => general.fetchCenterGroupArr,
);
/** ***************** FETCH ALL CENTER GROUP END *********************** */

/** ***************** FETCH ALL GROUP MEMBER START *********************** */
export const selectGetGroupMemberResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchGroupMemberResponse,
);

export const selectGetGroupMemberData = createSelector(
	[selectGeneral],
	(general) => general.fetchGroupMemberArr,
);
/** ***************** FETCH ALL GROUP MEMBER END *********************** */

/** ***************** FETCH BRANCH ACCOUNT LIST START *********************** */
export const selectFetchBranchAccountListResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchBranchAccountListResponse,
);

export const selectFetchBranchAccountListData = createSelector(
	[selectGeneral],
	(general) => general.fetchBranchAccountListArr,
);
/** ***************** FETCH BRANCH ACCOUNT LIST END *********************** */

/** ***************** FETCH GROUP LOAN INDEX START *********************** */
export const selectFetchGroupLoanIndexReponse = createSelector(
	[selectGeneral],
	(general) => general.fetchGroupLoanIndexListResponse,
);

export const selectFetchGroupLoanIndexData = createSelector(
	[selectGeneral],
	(general) => general.fetchGroupLoanIndexListArr,
);
/** ***************** FETCH GROUP LOAN INDEX END *********************** */

/** ***************** FETCH SEARCH LOAN INDEX START *********************** */
export const selectFetchSearchLoanIndexReponse = createSelector(
	[selectGeneral],
	(general) => general.fetchSearchLoanIndexListResponse,
);

export const selectFetchSearchLoanIndexData = createSelector(
	[selectGeneral],
	(general) => general.fetchSearchLoanIndexListArr,
);
/** ***************** FETCH SEARCH LOAN INDEX END *********************** */

/** ***************** FETCH VERSION DETAILS START *********************** */
export const selectFetchVersionDetailsResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchVersionResponse,
);

export const selectFetchVersionDetailsData = createSelector(
	[selectGeneral],
	(general) => general.fetchVersionArr,
);
/** ***************** FETCH VERSION DETAILS END *********************** */

/** ***************** UPDATE VERSION DETAILS START *********************** */
export const selectUpdateVersionDetailsResponse = createSelector(
	[selectGeneral],
	(general) => general.updateVersionResponse,
);

export const selectUpdateVersionDetailsData = createSelector(
	[selectGeneral],
	(general) => general.updateVersionArr,
);
/** ***************** UPDATE VERSION DETAILS END *********************** */

/** ***************** FETCH PINCODE DETAILS START *********************** */
export const selectFetchPincodeDetailsResponse = createSelector(
	[selectGeneral],
	(general) => general.fetchPincodeDetailsResponse,
);

export const selectFetchPincodeDetailsData = createSelector(
	[selectGeneral],
	(general) => general.fetchPincodeDetailsArr,
);
/** ***************** FETCH PINCODE DETAILS END *********************** */

/** ***************** GENERIC PINCODE DETAILS START *********************** */
export const selectGenericPincodeResponse = (fieldType: string) =>
	createSelector([selectGeneral], (general) => general.genericPincodeResponse?.[fieldType]);

export const selectGenericPincodeData = (fieldType: string) =>
	createSelector([selectGeneral], (general) => general.genericPincodeData?.[fieldType] || []);
/** ***************** GENERIC PINCODE DETAILS END *********************** */

/** ***************** FETCH ALL LOCATION BASED ON LEVEL START *********************** */
export const selectGetLocationListBasedLevelResp = createSelector(
	[selectGeneral],
	(general) => general.getLocationListBasedLevelResponse,
);

export const selectGetLocationListBasedLevelArr = createSelector(
	[selectGeneral],
	(general) => general.getLocationListBasedLevelArray,
);
/** ***************** FETCH ALL LOCATION BASED ON LEVEL END *********************** */

/** ***************** CHECK AUTHENDICATION START *********************** */
export const selectCheckAuthenticationResp = createSelector(
	[selectGeneral],
	(general) => general.checkGoogleAuthenticationResponse,
);
/** ***************** CHECK AUTHENDICATION END *********************** */

/** ***************** GET PURPOSE OF LOAN PROPOSAL START *********************** */
export const selectGetPurposeOfLoanProposalListResp = createSelector(
	[selectGeneral],
	(general) => general.getPurposeOfLoanProposalListResp,
);

export const selectGetPurposeOfLoanProposalListArr = createSelector(
	[selectGeneral],
	(general) => general.getPurposeOfLoanProposalListArr,
);
/** ***************** GET PURPOSE OF LOAN PROPOSAL END *********************** */

/** ***************** GET OFFICER BASED ON LEVEL LIST START *********************** */
export const selectGetOfficerBesedOnLevelListProposalResp = createSelector(
	[selectGeneral],
	(general) => general.getOfficerBesedOnLevelListProposalResp,
);

export const selectGetOfficerBesedOnLevelListProposalArr = createSelector(
	[selectGeneral],
	(general) => general.getOfficerBesedOnLevelListProposalArr,
);
/** ***************** GET OFFICER BASED ON LEVEL LIST END *********************** */

/** ***************** GET THRIFT LIST PROPOSAL START *********************** */
export const selectThriftListProposalResp = createSelector(
	[selectGeneral],
	(general) => general.getThriftListProposalResp,
);

export const selectThriftListProposalArr = createSelector(
	[selectGeneral],
	(general) => general.getThriftListProposalArr,
);
/** ***************** GET THRIFT LIST PROPOSAL END *********************** */

/** ***************** GET THRIFT DETAILS START *********************** */
export const selectThriftDetailsResp = createSelector(
	[selectGeneral],
	(general) => general.getThriftDetailsResp,
);

export const selectThriftDetailsArr = createSelector(
	[selectGeneral],
	(general) => general.getThriftDetailsArr,
);
/** ***************** GET THRIFT DETAILS END *********************** */

/** ***************** GET THRIFT TWO DETAILS START *********************** */
export const selectThriftTwoDetailsResp = createSelector(
	[selectGeneral],
	(general) => general.getThriftTwoDetailsResp,
);

export const selectThriftTwoDetailsArr = createSelector(
	[selectGeneral],
	(general) => general.getThriftTwoDetailsArr,
);
/** ***************** GET THRIFT TWO DETAILS END *********************** */

/** ***************** NON APPROVE MEMBER DETAILS START *********************** */
export const selectNonApproveMembersDetailsResp = createSelector(
	[selectGeneral],
	(general) => general.getNonApproveMembersDetailsResp,
);

export const selectNonApproveMembersDetailsArr = createSelector(
	[selectGeneral],
	(general) => general.getNonApproveMembersDetailsArr,
);
/** ***************** NON APPROVE MEMBER DETAILS END *********************** */

/** ***************** GET TODAY GOLD PRICE START *********************** */
export const selectTodayGoldPriceResponse = createSelector(
	[selectGeneral],
	(dashboard) => dashboard.todayGoldPriceResponse,
);

export const selectTodayGoldPriceData = createSelector(
	[selectGeneral],
	(dashboard) => dashboard.getTodayGoldPriceArr,
);
/** ***************** GET TODAY GOLD PRICE END *********************** */

/** ***************** UPDATE TODAY GOLD PRICE START *********************** */
export const selectUpdateTodayGoldPriceResponse = createSelector(
	[selectGeneral],
	(dashboard) => dashboard.updateTodayGoldPriceRep,
);
/** ***************** UPDATE TODAY GOLD PRICE END *********************** */
/** ***************** GET STATEWISE BRANCH START *********************** */
export const selectStatewisebranchesResp = createSelector(
	[selectGeneral],
	(general) => general.getStatewisebranchesDetailsResp,
);

export const selectStatewisebranchesArr = createSelector(
	[selectGeneral],
	(general) => general.getStatewisebranchesDetailsArr,
);
/** ***************** GET STATEWISE BRANCH END *********************** */
